module.exports = __webpack_public_path__ + "media/cladtech/about-aluminium-image-2-e3cd89fa.jpg";